export const apiField = 'use_default_max_block_north_corner';
interface DefaultMaxBlockNorthCornerField {
  type: string;
  apiField: string;
  label: string;
  id?: string;
  aria_label?: string;
}

const config: DefaultMaxBlockNorthCornerField = {
    type: 'Checkbox',
    label: 'Use Default Max Block For North Corner',
    apiField,
    id:'useDefaultMaxBlockNorthCorner',
    aria_label: 'Use Default Max Block For North Corner selection'
}

export default config;
